var a;!function(a){a.full="is_magalu_indica",a.market="is_mercado_full"}(a||(a={}));export{a as Variations};
